import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components';
import { useActivateThemeMutation } from '../../../../../hooks/useActivateThemeMutation';
import { useCurrentShopContext } from '../../../../../hooks/useCurrentShopContext';
import { useActiveThemeContext } from '../../../../../providers/ActiveThemeProvider';
import { useShopContext } from '../../../../../providers/ShopProvider';
import { useResetThemeMutation } from '../../../hooks/useResetThemeMutation';
import { useInstalledThemesContext } from '../../../providers/InstalledThemesProvider';
import { ThemeChangelogModal } from '../../ThemeChangelogModal/ThemeChangelogModal';
import { ThemeDeleteModal } from '../../ThemeDeleteModal/ThemeDeleteModal';
import { ThemeDuplicateModal } from '../../ThemeDuplicateModal/ThemeDuplicateModal';
import { ThemeRenameModal } from '../../ThemeRenameModal/ThemeRenameModal';
export const useSingleTheme = () => {
    const { currentShop } = useCurrentShopContext();
    const { open } = useModalContext();
    const { refetch } = useShopContext();
    const { activateThemeMutation } = useActivateThemeMutation();
    const { resetThemeMutation } = useResetThemeMutation();
    const { activeTheme, setActiveTheme } = useActiveThemeContext();
    const { themeList, currentTheme, isDirty, refetchThemeList, setThemeIsProcessing } = useInstalledThemesContext();
    const handleActivateSelectedTheme = ({ id }) => {
        setActiveTheme({ id, name: 'Main' });
        const activateTheme = () => {
            activateThemeMutation.mutate([{ shop_id: currentShop.id, theme_id: id }, { theme: { role: 'main' } }], {
                onSuccess: () => {
                    Toasts.notify('Selected theme has been activated', { type: 'info' });
                    refetchThemeList();
                    refetch();
                },
            });
        };
        if (isDirty) {
            open(ConfirmModal, {
                title: 'Your unsaved changes will be lost. Are you sure you want to activate this theme?',
                confirmLabel: 'Activate',
                confirmAppearance: 'primary',
                onConfirm: () => {
                    activateTheme();
                },
            });
        }
        else {
            activateTheme();
        }
    };
    const handleInactiveThemeEdit = ({ id, name }) => {
        if (isDirty) {
            open(ConfirmModal, {
                title: 'Your unsaved changes will be lost. Are you sure you want switch to this theme?',
                confirmLabel: 'Activate',
                confirmAppearance: 'primary',
                onConfirm: () => {
                    setActiveTheme({ id, name });
                },
            });
        }
        else {
            setActiveTheme({ id, name });
        }
    };
    const handleThemeReset = ({ id, handle }) => {
        open(ConfirmModal, {
            title: 'Reset theme to default settings',
            text: 'This will remove all of your customization on this theme. Are you sure you want to continue? This action cannot be reversed.',
            confirmLabel: 'Reset to default settings',
            confirmAppearance: 'destructive',
            onConfirm: () => {
                setThemeIsProcessing(handle);
                resetThemeMutation.mutate([{ shop_id: currentShop.id, shop_theme_id: id }], {
                    onSuccess: () => {
                        refetchThemeList();
                    },
                });
            },
        });
    };
    const handleThemeDuplicate = ({ id, name }) => {
        open(ThemeDuplicateModal, { id, name, onSuccess: refetchThemeList });
    };
    const handleThemeRename = ({ id, name, role }) => {
        open(ThemeRenameModal, {
            id,
            name,
            role,
            excludedNames: themeList.map(({ name }) => name).filter((themeName) => themeName !== name),
            onSuccess: refetchThemeList,
        });
    };
    const handleThemeDelete = ({ id, name }) => {
        open(ThemeDeleteModal, {
            id,
            name,
            onSuccess: () => {
                if (activeTheme.id === id && currentTheme) {
                    setActiveTheme({ id: currentTheme.id, name: 'Main' });
                }
                refetchThemeList();
            },
        });
    };
    const handleChangelogDisplay = ({ version, handle, }) => {
        open(ThemeChangelogModal, { version, handle });
    };
    return {
        handleActivateSelectedTheme,
        handleInactiveThemeEdit,
        handleThemeReset,
        handleThemeDuplicate,
        handleThemeRename,
        handleThemeDelete,
        handleChangelogDisplay,
    };
};
